import React from 'react'
import OrdersPage from './OrdersPage'
const DevolutionPage = props => {
  return <OrdersPage {...props} />
}
export default DevolutionPage
